import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "titlePages" }

import { watch, ref, Ref, onMounted, computed, shallowRef} from 'vue';
import axios from 'axios';
import Papa from "papaparse";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';
import maplibregl, { LngLatLike } from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS, TOKEN } from '@/constants/labels';
import { TIMEOUTTIME } from '@/constants/apis';
import { COLOR } from '@/constants/colors';
import CONSTAPIS from '@/constants/apis';
import CONSTMAPS from '@/constants/maps';

/********************************
 ********** INTERFACES **********
 *******************************/
import { DRIVE_OBS, DRIVE_PROPS } from '@/interfaces/SmartLink/Equipos';
import { TOPO_ITEMS } from '@/interfaces/SmartLink/Topology';
import { STRINGS } from '@/interfaces/SmartLink/General';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { showConsoleError } from '@/functions/errors';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
import { postHeatMapRAJANT, postKillProcessDrive, validateRunScripts } from '@/services/Smartlink/Drive';
import { getRajantLastGPS } from '@/services/Smartlink/Map';

/**
 * Titulo de la vista
 */
import miIconoPersonalizado from '@/assets/Icons/onlysolar.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'DriveRajantView',
  setup(__props) {

const { mdAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 *********** MAPLIBRE ***********
 *******************************/
const store = useStore();


const title = computed(() => 'Drive Rajant');

/**
 * Ancho del mapa
 */
const width = ref('350');

watch(mdAndDown,(valor:boolean) => {
    valor ? width.value = '100%' :  width.value = '350';
})

/**
 * borra los datos del HeatMap en el script de python
 */
async function deleteData(){


    const allData = await postKillProcessDrive();

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        console.log(allData)
    }
}

/**
 * Parametros para el HeatMap, minutos
 */
const minutes = ref(1);

/**
 * Parametros para el HeatMap, intervalo
 */
const interval = ref(15);

/**
 * Deshabilita el boton mientras se realiza la peticion
 */
const disabledAXIOS = ref(false);

/**
 * Inicia el proceso del HeatMap mandando los parametros al script de python
 */
async function startHeatMap(){

    allClearData();
    haulTruckSelected.value = '';
    const params = {
        minutes: minutes.value,
        interval: interval.value
    }

    disabledAXIOS.value = true;

    // const allData = await postHeatMapRAJANT(params)

    // // disabledAXIOS.value = false;

    // if( allData.status === 400 ){
    //     store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    // }
    // if( allData.status === 200 ){
    //     console.log(allData.data)
    // }
}

/**
 * Indica si el proceso del HeatMap esta corriendo
 */
const running = ref(false);

let intervalAXIOS: number | null = null;

/**
 * Observa el valor de disabledAXIOS para iniciar el timer y el polling
 */
watch(disabledAXIOS,(a)=> {
    if(a) {
        startTimer();
        // startPolling();
    }
})

/**
 * Inicia el polling para verificar el estado del HeatMap
 */
// function startPolling() {
//   if (running.value) return;

//   running.value = true;
//   validateRunScript();

//   intervalAXIOS = window.setInterval(validateRunScript, 5000);
// }

// /**
//  * Detiene el polling
//  */
// function stopPolling() {
//   running.value = false;
//   disabledAXIOS.value = false;
//   if (intervalAXIOS) {
//     clearInterval(intervalAXIOS);
//     intervalAXIOS = null;
//   }
// }


// /**
//  * Valida el estado del script del HeatMap, Si existe el código dataRajant, el script sigue corriendo
//  */
// async function validateRunScript(){
//      const allData = await validateRunScripts()

//      if( allData.status === 400 ){
//         store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
//     }
//     if( allData.status === 200 ){
//         if(allData.data.body === '') {
//             stopPolling()
//         }
//         else{
//             if(!allData.data.includes('dataRajant')){
//                 store.commit('showSnackBar', {type: LABELS.add, msg: t('snackbar.heatmapOK'), valor : true});
//                 stopPolling()
//             }
//         }
        
//     }
// }

/**
 * Progreso del HeatMap
 */
const progress = ref(0);

/**
 * Indica si el timer esta corriendo o no
 */
const isRunning = ref(false);

let totalSeconds = 0;
let elapsedSeconds = 0;
let intervalId: ReturnType<typeof setInterval> | null = null;

/**
 * Inicia el timer para la barra de progreso del HeatMap
 */
function startTimer (){
  if (!minutes.value || minutes.value <= 0) return;

  if (intervalId) {
    clearInterval(intervalId);
  }

  totalSeconds = minutes.value * 60;
  elapsedSeconds = 0;
  progress.value = 0;
  isRunning.value = true;

  intervalId = setInterval(() => {
    elapsedSeconds++;
    progress.value = (elapsedSeconds / totalSeconds) * 100;

    if (elapsedSeconds >= totalSeconds) {
      clearInterval(intervalId!);
      isRunning.value = false;
      disabledAXIOS.value = false;
    }
  }, 1000);
}

/**
 * checkbox del ETH0
 */
const selectedETH0:Ref<boolean> = ref(true);

/**
 * checkbox del RPTPEER
 */
const selectedRPTPEER:Ref<boolean> = ref(false);

/**
 * checkbox del WLAN0
 */
const selectedWLAN0:Ref<boolean> = ref(false);

/**
 * checkbox del WLAN1
 */
const selectedWLAN1:Ref<boolean> = ref(false);

/**
 * checkbox del WLAN2
 */
const selectedWLAN2:Ref<boolean> = ref(false);

/**
 * checkbox del WLAN3
 */
const selectedWLAN3:Ref<boolean> = ref(false);

/**
 * checkbox del LATENCIA
 */
const selectedLATENCIA:Ref<boolean>     = ref(false);

/**
 * Muestra error si no hay datos
 */
const showError                         = ref(false);

/**
 * Muestra los checkbox
 */
const showCheckBoxes                    = ref(false);

const COLORRED      = COLOR.red;
const COLORYELLOW   = COLOR.yellow;
const COLORGREEN    = COLOR.green;
const COLORGREY     = COLOR.grey;


/**
 * Obtiene el color dependiendo del valor
 * @param value 
 * @param limit 
 * @param colors 
 */
const getColorByValue = (value: number, limit:number[], colors:string[]) => {
    if( value === 0 ) return COLORGREY;
    let finalColor = colors;
    let selectedColor = COLORGREY;
    limit.forEach((limited,i) => {
        if(value > limited ) selectedColor = finalColor[i]
    })
    return selectedColor
}

/**
 * Array Final de los datos ETH0
 */
const finalETH0Array    = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de los datos ETH0
 */
const finalETH0Object   = ref<DRIVE_OBS>({'features': [], "type": ''});


/**
 * Array Final de los datos RPTPEER
 */
const finalRPTPEERArray    = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de los datos RPTPEER
 */
const finalRPTPEERObject   = ref<DRIVE_OBS>({'features': [], "type": ''});


/**
 * Array Final de los datos WLAN0
 */
const finalWLAN0Array    = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de los datos WLAN0
 */
const finalWLAN0Object   = ref<DRIVE_OBS>({'features': [], "type": ''});

/**
 * Array Final de los datos WLAN1
 */
const finalWLAN1Array    = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de los datos WLAN1
 */
const finalWLAN1Object   = ref<DRIVE_OBS>({'features': [], "type": ''});

/**
 * Array Final de los datos WLAN2
 */
const finalWLAN2Array    = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de los datos WLAN2
 */
const finalWLAN2Object   = ref<DRIVE_OBS>({'features': [], "type": ''});

/**
 * Array Final de los datos WLAN3
 */
const finalWLAN3Array    = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de los datos WLAN3
 */
const finalWLAN3Object   = ref<DRIVE_OBS>({'features': [], "type": ''});

/**
 * Array Final de los datos LATENCIA
 */
const finalLATENCIAArray    = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de los datos LATENCIA
 */
const finalLATENCIAObject   = ref<DRIVE_OBS>({'features': [], "type": ''});


function getFinalPositions (lat:number, lng:number) {
    let lat1 = lat + 0.0002;
    let lng1 = lng + 0.0002;
    let finalItem = [
        [ lng,  lat  ],
        [ lng1, lat  ],
        [ lng1, lat1 ],
        [ lng,  lat1 ],
        [ lng,  lat  ],
    ]
    return finalItem
}

/**
 * Llama a la funcion getInfoByIP
 * Envia el parametro del valor que desea obtener
 * Recibe objeto {
 *  ip : name
 * }
 * se usa para la lista del SELECT
 */
// const finalNameByIP:Ref<STRINGS> = ref(getInfoByIP('name'));


/**
 * Lista final de camiones
 */
const finalListTruck:Ref<TOPO_ITEMS[]>      = ref([]);

/**
 * ?Lista computada de camiones?
 */
const computedListTruck = computed(() => finalListTruck.value)

/**
 * ?Lista intermedia de camiones?
 */
const haulTrucksList:Ref<TOPO_ITEMS[]>      = ref([]);

/**
 * Obtiene todos los camiones de la API
 */
const getAllHaulTrucks = async() => {

    await axios.get(CONSTAPIS.APIS.value.drive.geAllIPDriveRAJANT, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((response) => {
        let finalItems = response.data.body;
        finalItems.forEach((item:string) => {
            let prevIP = item.split('.')
            let finalIP = `${prevIP[0]}.${prevIP[1]}.${prevIP[2]}.${prevIP[3]}`
            haulTrucksList.value.push({
                title   : finalIP,
                value   : finalIP,
            })
        })
    })
    .catch(function (error) {
        showConsoleError(error);
    });

    finalListTruck.value = haulTrucksList.value;
}


async function allClearData(){
    clearLayerSource('LayerETH0','SourceETH0');
    clearLayerSource('LayerRPTPEER','SourceRPTPEER');
    clearLayerSource('LayerWLAN0','SourceWLAN0');
    clearLayerSource('LayerWLAN1','SourceWLAN1');
    clearLayerSource('LayerWLAN2','SourceWLAN2');
    clearLayerSource('LayerWLAN3','SourceWLAN3');
    clearLayerSource('LayerLATENCIA','SourceLATENCIA');

    selectedETH0.value      = true;
    selectedRPTPEER.value   = false;
    selectedWLAN0.value     = false;
    selectedWLAN1.value     = false;
    selectedWLAN2.value     = false;
    selectedWLAN3.value     = false;
    selectedLATENCIA.value  = false;
    showError.value         = false;
    showCheckBoxes.value    = false;
    finalETH0Array.value    = [];
    finalRPTPEERArray.value = [];  
    finalWLAN0Array.value   = [];  
    finalWLAN1Array.value   = [];  
    finalWLAN2Array.value   = [];  
    finalWLAN3Array.value   = [];  
    finalLATENCIAArray.value = [];
}


/**
 * Equipo Seleccionado en el HTML
 */
const haulTruckSelected     = ref('');


/**
 * Obtiene la información del equipo seleccionado
 */
async function getHaulTruckPositions() {

    allClearData();

    let params = {
        ip : haulTruckSelected.value
    }
    
    let api = CONSTAPIS.APIS.value.drive.getInfoDriveRAJANTByIP;
    await axios.get(api,{params:params, headers: { "Authorization": `Bearer ${TOKEN}`}}).then(async(response)=>{
        /* eslint-disable */
        let finalItems:any = Papa.parse(response.data.body, {
            header: true, // Usa la primera fila como nombres de las claves en el JSON
            skipEmptyLines: true, // Ignorar líneas vacías
        });

        if(finalItems.data.length > 0) {
            let index = 0;

            finalItems.data.forEach((item:any) => {
                let prevETH0    = item.eth0 ? JSON.parse(item.eth0.replace(/'/g, '"')) : null;
                let prevRPTPEER = item.rptPeer ? JSON.parse(item.rptPeer.replace(/'/g, '"')) : null;
                let prevWLAN0   = item.wlan0 ? JSON.parse(item.wlan0.replace(/'/g, '"')) : null;
                let prevWLAN1   = item.wlan1 ? JSON.parse(item.wlan1.replace(/'/g, '"')) : null;
                let prevWLAN2   = item.wlan2 ? JSON.parse(item.wlan2.replace(/'/g, '"')) : null;
                let prevWLAN3   = item.wlan3 ? JSON.parse(item.wlan3.replace(/'/g, '"')) : null;
                index = index + 1;
                
                let lat   = 30.972732;
                let lng   = -110.34928166;

                if(item.latitud && item.latitud !== '')     { lat = parseFloat(item.latitud??'0'); }
                if(item.longitud && item.longitud !== '')   { lng = parseFloat(item.longitud??'0'); }
                if(item.gpsLat && item.gpsLat !== '')       { lat = parseFloat(item.gpsLat??'0'); }
                if(item.gpsLong && item.gpsLong !== '')     { lng = parseFloat(item.gpsLong??'0'); }

                let costeth0    = (prevETH0) ? prevETH0[2] : 0;
                let finalINFOeth0 = (prevETH0) ? `IP : ${prevETH0[0]} <br/> NOMBRE: ${prevETH0[1]} <br/> COSTO: ${prevETH0[2]} ` : '';

                let costrptpeer = (prevRPTPEER) ? prevRPTPEER[2] : 0;
                let finalINFOrptpeer = (prevRPTPEER) ? `IP : ${prevRPTPEER[0]} <br/> NOMBRE: ${prevRPTPEER[1]} <br/> COSTO: ${prevRPTPEER[2]} ` : '';

                let costwlan0   = (prevWLAN0) ? prevWLAN0[1] : 0;
                let finalINFOwlan0 = (prevWLAN0) ? `IP : ${prevWLAN0[0]} <br/> COSTO: ${prevWLAN0[1]} <br/> PEER RSSI: ${prevWLAN0[2]} <br/> SIGNAL: ${prevWLAN0[3]} <br/> NOISE: ${prevWLAN0[4]}` : '';
                
                let costwlan1   = (prevWLAN1) ? prevWLAN1[1] : 0;
                let finalINFOwlan1 = (prevWLAN1) ? `IP : ${prevWLAN1[0]} <br/> COSTO: ${prevWLAN1[1]} <br/> PEER RSSI: ${prevWLAN1[2]} <br/> SIGNAL: ${prevWLAN1[3]} <br/> NOISE: ${prevWLAN1[4]}` : '';

                let costwlan2   = (prevWLAN2) ? prevWLAN2[1] : 0;
                let finalINFOwlan2 = (prevWLAN2) ? `IP : ${prevWLAN2[0]} <br/> COSTO: ${prevWLAN2[1]} <br/> PEER RSSI: ${prevWLAN2[2]} <br/> SIGNAL: ${prevWLAN2[3]} <br/> NOISE: ${prevWLAN2[4]}` : '';

                let costwlan3   = (prevWLAN3) ? prevWLAN3[1] : 0;
                let finalINFOwlan3 = (prevWLAN3) ? `IP : ${prevWLAN3[0]} <br/> COSTO: ${prevWLAN3[1]} <br/> PEER RSSI: ${prevWLAN3[2]} <br/> SIGNAL: ${prevWLAN3[3]} <br/> NOISE: ${prevWLAN3[4]}` : '';
                
                let latencia    = item.latencia !== '' && item.latencia ? parseFloat(item.latencia) : 0; 
                let finalINFOLatencia = (latencia) ? `LATENCIA: ${latencia}ms ` : '';

                let coloreth0       = getColorByValue(costeth0, [0,5000,10000],[COLORGREEN,COLORYELLOW, COLORRED]);
                let colorrptpeer    = getColorByValue(costrptpeer, [0,5000,10000],[COLORGREEN,COLORYELLOW, COLORRED]);
                let colorwlan0      = getColorByValue(costwlan0, [0,5000,10000],[COLORGREEN,COLORYELLOW, COLORRED]);
                let colorwlan1      = getColorByValue(costwlan1, [0,5000,10000],[COLORGREEN,COLORYELLOW, COLORRED]);
                let colorwlan2      = getColorByValue(costwlan2, [0,5000,10000],[COLORGREEN,COLORYELLOW, COLORRED]);
                let colorwlan3      = getColorByValue(costwlan3, [0,5000,10000],[COLORGREEN,COLORYELLOW, COLORRED]);
                let colorlatencia   = getColorByValue(latencia, [0,100,200],[COLORGREEN,COLORYELLOW, COLORRED]);

                prevETH0    ? postPORTItems('ETH0',lat, lng, coloreth0, costeth0 !== 0 ? finalINFOeth0: `Fuera de Linea`,index,item.fecha) : null;
                prevRPTPEER ? postPORTItems('RPTPEER',lat, lng, colorrptpeer, costrptpeer !== 0 ? finalINFOrptpeer: `Fuera de Linea`,index,item.fecha) : null;
                prevWLAN0   ? postPORTItems('WLAN0',lat, lng, colorwlan0, costwlan0 !== 0 ? finalINFOwlan0 : `Fuera de Linea`,index,item.fecha) : null;
                prevWLAN1   ? postPORTItems('WLAN1',lat, lng, colorwlan1, costwlan1 !== 0 ? finalINFOwlan1 : `Fuera de Linea`,index,item.fecha) : null;
                prevWLAN2   ? postPORTItems('WLAN2',lat, lng, colorwlan2, costwlan2 !== 0 ? finalINFOwlan2 : `Fuera de Linea`,index,item.fecha) : null;
                prevWLAN3   ? postPORTItems('WLAN3',lat, lng, colorwlan3, costwlan3 !== 0 ? finalINFOwlan3 : `Fuera de Linea`,index,item.fecha) : null;
                latencia   ? postPORTItems('LATENCIA',lat, lng, colorlatencia, finalINFOLatencia ,index,item.fecha) : null;
            })

            if(finalETH0Array.value.length > 0) {
                finalETH0Object.value = { "features" : finalETH0Array.value, type : "FeatureCollection" };
                await setSourceAndLayer('SourceETH0',finalETH0Object.value,'LayerETH0');
            }

            if(finalRPTPEERArray.value.length > 0) {
                finalRPTPEERObject.value = { "features" : finalRPTPEERArray.value, type : "FeatureCollection" };
                await setSourceAndLayer('SourceRPTPEER',finalRPTPEERObject.value,'LayerRPTPEER');
            }

            if(finalWLAN0Array.value.length > 0) {
                finalWLAN0Object.value = { "features" : finalWLAN0Array.value, type : "FeatureCollection" };
                await setSourceAndLayer('SourceWLAN0',finalWLAN0Object.value,'LayerWLAN0');
            }

            if(finalWLAN1Array.value.length > 0) {
                finalWLAN1Object.value = { "features" : finalWLAN1Array.value, type : "FeatureCollection" };
                await setSourceAndLayer('SourceWLAN1',finalWLAN1Object.value,'LayerWLAN1');
            }

            if(finalWLAN2Array.value.length > 0) {
                finalWLAN2Object.value = { "features" : finalWLAN2Array.value, type : "FeatureCollection" };
                await setSourceAndLayer('SourceWLAN2',finalWLAN2Object.value,'LayerWLAN2');
            }

            if(finalWLAN3Array.value.length > 0){
                finalWLAN3Object.value = { "features" : finalWLAN3Array.value, type : "FeatureCollection" };
                await setSourceAndLayer('SourceWLAN3',finalWLAN3Object.value,'LayerWLAN3');
            }

            if(finalLATENCIAArray.value.length > 0){
                finalLATENCIAObject.value = { "features" : finalLATENCIAArray.value, type : "FeatureCollection" };
                await setSourceAndLayer('SourceLATENCIA',finalLATENCIAObject.value,'LayerLATENCIA');
            }

            clearLayerSource('LayerRPTPEER','SourceRPTPEER');
            clearLayerSource('LayerWLAN0','SourceWLAN0');
            clearLayerSource('LayerWLAN1','SourceWLAN1');
            clearLayerSource('LayerWLAN2','SourceWLAN2');
            clearLayerSource('LayerWLAN3','SourceWLAN3');
            clearLayerSource('LayerLATENCIA','SourceLATENCIA');
            showCheckBoxes.value = true;
        }
        else {
            showError.value = true;
            showCheckBoxes.value = false;
        }
    })
    .catch(function (error) {
        showConsoleError(error);
    });
}

/**
 * Agrega los items al array correspondiente con formato geojson
 * @param tipo 
 * @param latitud 
 * @param longitud 
 * @param color 
 * @param valor 
 * @param index 
 * @param fecha 
 */
function postPORTItems (tipo:string, latitud:number, longitud:number, color:string, valor:string, index:number, fecha:string) {
    let finalITEM = {                        
            "type": "Feature",
            "properties": {
                "level": 0,
                "name": `AllGraph${tipo}`,
                "height": 40,
                "base_height": 0,
                "color": color,
                "center": [longitud,latitud],
                "valor": valor,
                "fecha" : fecha
            },
            "geometry": {
                "coordinates": [ getFinalPositions(latitud,longitud) ],
                "type": "Polygon"
            },
            'id': index 
    }
    if(tipo.toUpperCase() === 'ETH0')       { finalETH0Array.value.push(finalITEM) }
    if(tipo.toUpperCase() === 'RPTPEER')    { finalRPTPEERArray.value.push(finalITEM) }
    if(tipo.toUpperCase() === 'WLAN0')      { finalWLAN0Array.value.push(finalITEM) }
    if(tipo.toUpperCase() === 'WLAN1')      { finalWLAN1Array.value.push(finalITEM) }
    if(tipo.toUpperCase() === 'WLAN2')      { finalWLAN2Array.value.push(finalITEM) }
    if(tipo.toUpperCase() === 'WLAN3')      { finalWLAN3Array.value.push(finalITEM) }
    if(tipo.toUpperCase() === 'LATENCIA')   { finalLATENCIAArray.value.push(finalITEM) }
}

/**
 * Agrega el Layer y el Source al mapa
 * @param source 
 * @param alldata 
 * @param layer 
 */
async function setSourceAndLayer(source:string, alldata:DRIVE_OBS, layer:string) {

    const mySource = map.getSource(source);
    if(mySource === undefined){ 

        map.addSource(source, { 'type': 'geojson', 'data': alldata});        
        map.addLayer({
            'id': layer,
            'type': 'fill-extrusion',
            'source': source,
            'paint': {
                'fill-extrusion-color': ['get', 'color'],
                'fill-extrusion-height': ['get', 'height'],
                'fill-extrusion-base': ['get', 'base_height'],
                'fill-extrusion-opacity':1,
            }
        });
        
        const popup = new maplibregl.Popup({
            closeButton: false,
            closeOnClick: false
        });

        /* eslint-disable */
        map.on('mouseenter', layer, (e:any) => {
            map.getCanvas().style.cursor = 'pointer';
            
            const coordinates:any = [e.lngLat.lng, e.lngLat.lat];
            const valor = e.features[0].properties.valor ;
            let mensaje = `${valor}` 

            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }

            popup.setLngLat(coordinates).setHTML(mensaje).addTo(map);
        });

        map.on('mouseleave', layer, () => {
            map.getCanvas().style.cursor = '';
            popup.remove();
        });
    }
    else{
        mySource.setData(alldata)
    }
}

/**
 * Limpia el layer y el source del mapa
 * @param layer 
 * @param source 
 */
function clearLayerSource(layer:string, source:string) {
    if(map.getLayer(layer)) { map.removeLayer(layer); }
    if(map.getSource(source)) { map.removeSource(source); }
}

/**
 * Observa los checkbox para agregar o quitar layers del mapa
 * @param selectedVar 
 * @param type 
 * @param source 
 * @param finalObject 
 * @param layer 
 */
function watchLayer(selectedVar: Ref<boolean>, source: string, finalObject: Ref<DRIVE_OBS>, layer: string) {
    watch(selectedVar, (state) => {
        if (state) {
            setSourceAndLayer(source, finalObject.value, layer);
        } else {
            clearLayerSource(layer, source);
        }
    });
}; 

watchLayer(selectedETH0,  'SourceETH0', finalETH0Object, 'LayerETH0');
watchLayer(selectedRPTPEER,  'SourceRPTPEER', finalRPTPEERObject, 'LayerRPTPEER');
watchLayer(selectedWLAN0, 'SourceWLAN0', finalWLAN0Object, 'LayerWLAN0');
watchLayer(selectedWLAN1, 'SourceWLAN1', finalWLAN1Object, 'LayerWLAN1');
watchLayer(selectedWLAN2, 'SourceWLAN2', finalWLAN2Object, 'LayerWLAN2');
watchLayer(selectedWLAN3, 'SourceWLAN3', finalWLAN3Object, 'LayerWLAN3');
watchLayer(selectedLATENCIA, 'SourceLATENCIA', finalLATENCIAObject, 'LayerLATENCIA');

/**
 * colores para el KMZ
 */
const color:STRINGS = {
    '#E04637' : '#lineStyleRed',
    '#F9DC4B' : '#lineStyleYellow',
    '#427739' : '#lineStyleGreen',
    '#CAC8C8' : '#lineStyleGrey',
    '#00A5E8' : '#lineStyleBlue',
}

/**
 * genera todas las coordenadas del KMZ
 * @param finalObject 
 */
function getAllCoordinates(finalObject: Ref<DRIVE_OBS>) {
    let prevCoordinates = '';
    if(Object.keys(finalObject.value).length > 0){
        finalObject.value.features.forEach((element:DRIVE_PROPS) => {
            const finalCoord1 = (element.geometry.coordinates[0][0]);
            const finalCoord2 = (element.geometry.coordinates[0][1]);
            const finalCoord3 = (element.geometry.coordinates[0][2]);
            const finalCoord4 = (element.geometry.coordinates[0][3]);
            const finalCoord5 = (element.geometry.coordinates[0][4]);
            let someCoordinates = `
                <Placemark>
                    <name>${element.id}</name>
                    <description> 
                        <b>Detalles: </b> <br/>
                        Posicion: ${element.properties.center}<br/>
                        Valor:${element.properties.valor}.<br/>
                        Fecha:${element.properties.fecha}.
                    </description>
                    <styleUrl>${color[element.properties.color??'#CAC8C8']}</styleUrl>
                    <MultiGeometry>
                        <Polygon>
                            <extrude>1</extrude>
                            <altitudeMode>relativeToGround</altitudeMode>
                            <outerBoundaryIs>
                                <LinearRing>
                                <coordinates>
                                    ${finalCoord1[0]},${finalCoord1[1]},0
                                    ${finalCoord2[0]},${finalCoord2[1]},0
                                    ${finalCoord3[0]},${finalCoord3[1]},0
                                    ${finalCoord4[0]},${finalCoord4[1]},0
                                    ${finalCoord5[0]},${finalCoord5[1]},0
                                </coordinates>
                                </LinearRing>
                            </outerBoundaryIs>
                        </Polygon>
                        <Polygon>
                            <extrude>1</extrude>
                            <altitudeMode>relativeToGround</altitudeMode>
                            <outerBoundaryIs>
                                <LinearRing>
                                <coordinates>
                                    ${finalCoord1[0]},${finalCoord1[1]},20
                                    ${finalCoord2[0]},${finalCoord2[1]},20
                                    ${finalCoord3[0]},${finalCoord3[1]},20
                                    ${finalCoord4[0]},${finalCoord4[1]},20
                                    ${finalCoord5[0]},${finalCoord5[1]},20
                                </coordinates>
                                </LinearRing>
                            </outerBoundaryIs>
                        </Polygon>
                    </MultiGeometry>
                </Placemark>
            `
            prevCoordinates = prevCoordinates + someCoordinates
        })
    }

    return prevCoordinates
}

/**
 * Genera los folders del KMZ
 * @param title 
 * @param finalCoords 
 */
function getFolderItems (title:string,finalCoords:string) {
    let folder = finalCoords === '' ? '' :  `
        <Folder> 
            <name> ${title} </name>
            ${finalCoords}
        </Folder>
    `
    return folder
}

/**
 * Genera el archivo KMZ
 */
async function getKMZ() {

    const iconUrl = window.location.origin + miIconoPersonalizado;
    
 // Contenido del archivo KML
 let kmlContent = `<?xml version="1.0" encoding="UTF-8"?>
  <kml xmlns="http://www.opengis.net/kml/2.2">
    <Document>
      <name>EQUIPO : ${haulTruckSelected.value}</name>

    <Style id="lineStyleRed">
      <LineStyle>
        <color>ff00ffff</color>
        <width>1</width>
      </LineStyle>
      <PolyStyle>
        <color>ff00ffff</color> 
        <fill>1</fill>
      </PolyStyle>
    </Style>

    <Style id="lineStyleYellow">
      <LineStyle>
        <color>ff00ffff</color>
        <width>1</width>
      </LineStyle>
      <PolyStyle>
        <color>ff00ffff</color> 
        <fill>1</fill>
      </PolyStyle>
    </Style>

    <Style id="lineStyleGreen">
      <LineStyle>
        <color>ff00ff00</color>
        <width>1</width>
      </LineStyle>
      <PolyStyle>
        <color>ff00ff00</color> 
        <fill>1</fill>
      </PolyStyle>
    </Style>

    <Style id="lineStyleGrey">
      <LineStyle>
        <color>ff808080</color>
        <width>1</width>
      </LineStyle>
      <PolyStyle>
        <color>ff808080</color> 
        <fill>1</fill>
      </PolyStyle>
    </Style>

    <Style id="lineStyleBlue">
      <LineStyle>
        <color>ffff0000</color>
        <width>1</width>
      </LineStyle>
      <PolyStyle>
        <color>ffff0000</color> 
        <fill>1</fill>
      </PolyStyle>      
    </Style>
    <Style id="customMarkerStyle">
        <IconStyle>
            <scale>1.2</scale>
            <Icon>
                <href>${iconUrl}</href> 
            </Icon>
        </IconStyle>
    </Style>
    `
    const finalETH0Coords       = getAllCoordinates(finalETH0Object)
    const finalRPTPEERCoords    = getAllCoordinates(finalRPTPEERObject)
    const finalWLAN0Coords      = getAllCoordinates(finalWLAN0Object)
    const finalWLAN1Coords      = getAllCoordinates(finalWLAN1Object)
    const finalWLAN2Coords      = getAllCoordinates(finalWLAN2Object)
    const finalWLAN3Coords      = getAllCoordinates(finalWLAN3Object)
    const finalLATENCIACoords   = getAllCoordinates(finalLATENCIAObject)

    let finalFolderETH0         = getFolderItems('ETH0',finalETH0Coords)
    let finalFolderRPTPEER      = getFolderItems('RPTPEER',finalRPTPEERCoords)
    let finalFolderWLAN0        = getFolderItems('WLAN0',finalWLAN0Coords)
    let finalFolderWLAN1        = getFolderItems('WLAN1',finalWLAN1Coords)
    let finalFolderWLAN2        = getFolderItems('WLAN2',finalWLAN2Coords)
    let finalFolderWLAN3        = getFolderItems('WLAN3',finalWLAN3Coords)
    let finalFolderLATENCIA     = getFolderItems('LATENCIA',finalLATENCIACoords)
      
    let markersFolder = ` <Folder> <name> Equipos Ap Fijo y Ap Movil </name> `
    allMarkerData.value.forEach((marker:any) => {
        if(marker.tipo.toLowerCase() === 'ap fijo' || marker.tipo.toLowerCase() === 'ap movil') {   
            const coords = JSON.parse(marker.gps);
            const lng = coords[1];
            const lat = coords[0];
            let markerItem = `
                <Placemark>
                    <name>${marker.name}</name>
                    <description>Tipo: ${marker.tipo} <br/> IP: ${marker.ip} </description>
                    <styleUrl>#customMarkerStyle</styleUrl>
                    <Point>
                        <coordinates>${lng},${lat},0</coordinates>
                    </Point>
                </Placemark>
            `
            markersFolder = markersFolder + markerItem
        }
    })
    markersFolder = markersFolder + `</Folder>`

  let finalKmlConent = `
   </Document>
  </kml>
  `

  kmlContent = kmlContent + markersFolder + finalFolderETH0 + finalFolderRPTPEER + finalFolderWLAN0 + finalFolderWLAN1 + finalFolderWLAN2 + finalFolderWLAN3 + finalFolderLATENCIA + finalKmlConent;



//   Crear un Blob con el contenido del KML
  const blob = new Blob([kmlContent], { type: "application/vnd.google-earth.kml+xml" });
  const url = URL.createObjectURL(blob);

  // Crear un enlace y simular el clic para descargar
  const link = document.createElement("a");
  link.href = url;
  link.download = `KML-EQUIPO: ${haulTruckSelected.value}.kml`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}


const allMarkerData = ref<any>([]);

async function getAllRajantPositions() {
    const allData = await getRajantLastGPS()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        allMarkerData.value = allData.data;
        agregarMarcadores(map, allData.data);
    }
}



// 1. Variables reactivas
const mostrarEquipos = ref(true); // Estado del checkbox (empieza marcado)
const marcadoresActivos = shallowRef([]); // Aquí guardaremos los pines para poder modificarlos

// 2. Observador (Watch): Reacciona cuando haces clic en el checkbox
watch(mostrarEquipos, (estaVisible) => {
  // Recorremos todos los marcadores guardados y cambiamos su estilo CSS
  marcadoresActivos.value.forEach((marker:any) => {
    const elementoHtml = marker.getElement();
    // Si estaVisible es true, lo mostramos (block). Si es false, lo ocultamos (none)
    elementoHtml.style.display = estaVisible ? 'block' : 'none';
  });
});

// 3. Tu función actualizada
const agregarMarcadores = (mapaInstancia:any, datosEquipos:any) => {
  if (!mapaInstancia) return;

  // Limpiamos los marcadores anteriores si la API se llama múltiples veces
  marcadoresActivos.value.forEach((m:any) => m.remove());
  const nuevosMarcadores:any = []; // Arreglo temporal

  datosEquipos.forEach((equipo:any) => {
    if(equipo.tipo.toLowerCase() === 'ap fijo' || equipo.tipo.toLowerCase() === 'ap movil') {
        const coords = JSON.parse(equipo.gps);
        const lng = coords[1];
        const lat = coords[0];

        // Contenedor principal del marcador
        const el = document.createElement('div');
        el.style.backgroundImage = `url(${miIconoPersonalizado})`;
        el.style.width = '32px';  
        el.style.height = '32px'; 
        el.style.backgroundSize = 'cover';
        el.style.backgroundPosition = 'center';
        el.style.cursor = 'pointer';

        // Etiqueta del nombre
        const nameLabel = document.createElement('div');
        nameLabel.textContent = equipo.name; 
        nameLabel.style.color = '#ffffff';
        nameLabel.style.backgroundColor = 'rgba(0, 0, 0, 0.75)'; 
        nameLabel.style.fontSize = '11px';
        nameLabel.style.fontWeight = 'bold';
        nameLabel.style.padding = '2px 6px';
        nameLabel.style.borderRadius = '4px';
        nameLabel.style.position = 'absolute';
        nameLabel.style.top = '100%'; 
        nameLabel.style.left = '50%';
        nameLabel.style.transform = 'translate(-50%, 2px)'; 
        nameLabel.style.whiteSpace = 'nowrap'; 
        
        el.appendChild(nameLabel);

        // Respetar el estado actual del checkbox antes de agregar al mapa
        if (!mostrarEquipos.value) {
        el.style.display = 'none';
        }

        // Crear el marcador
        const marker = new maplibregl.Marker({
        element: el,
        anchor: 'bottom'
        })
        .setLngLat([lng, lat])
        .addTo(mapaInstancia);

        // Guardar en el arreglo temporal
        nuevosMarcadores.push(marker);
    }
  });

  // Guardamos todos los marcadores nuevos en la variable reactiva
  marcadoresActivos.value = nuevosMarcadores;
};

let map:any = '' ;
const centerMap = ref<LngLatLike>([CONSTMAPS.longitud.value,CONSTMAPS.latitud.value])

onMounted(async() => {

    getAllHaulTrucks();
    
    map  = new maplibregl.Map({
        container: 'map',
        center: centerMap.value,
        zoom: 14,
        pitch: 40,
        bearing: 30,
        antialias: true,
        style: 'https://api.maptiler.com/maps/satellite/style.json?key=6JWVt6LFaY22nquimZpF',
    });
    
    map.addControl(new maplibregl.NavigationControl());

    
    getAllRajantPositions();
})


return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    class: "defaultCard",
    color: "bgtopology"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(title.value), 1),
      _createVNode(_component_v_row, { class: "ma-0 mt-8" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_sheet, {
            color: "transparent",
            style: _normalizeStyle(_unref(mdAndDown) ?'width: 100%' :`width: calc(100% - ${width.value}px)`)
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createElementVNode("div", { id: "map" }, null, -1)
            ]))]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_v_sheet, {
            color: "transparent",
            class: "pa-4 pr-0",
            width: width.value
          }, {
            default: _withCtx(() => [
              _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "subtitlePages" }, "Heatmap", -1)),
              _createVNode(_component_v_row, { class: "ma-0 mt-3 mb-3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "6",
                    class: "pa-0 pr-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        variant: "outlined",
                        density: "compact",
                        label: "Duración (min.)",
                        type: "number",
                        "hide-spin-buttons": "",
                        modelValue: minutes.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((minutes).value = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "6",
                    class: "pa-0 pl-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        variant: "outlined",
                        density: "compact",
                        label: "Intervalo (seg.)",
                        type: "number",
                        "hide-spin-buttons": "",
                        modelValue: interval.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((interval).value = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    onClick: startHeatMap,
                    block: "",
                    color: "success",
                    disabled: disabledAXIOS.value
                  }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createTextVNode(" Iniciar ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    onClick: deleteData,
                    block: "",
                    color: "purple",
                    disabled: disabledAXIOS.value
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode(" borrar datos ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }),
              (disabledAXIOS.value)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    class: "ma-0 mt-2 mb-4",
                    justify: "center"
                  }, {
                    default: _withCtx(() => [
                      _cache[15] || (_cache[15] = _createTextVNode(" Cargando Información ", -1)),
                      _createVNode(_component_v_progress_linear, {
                        "model-value": progress.value,
                        height: "20",
                        color: "green",
                        striped: "",
                        active: isRunning.value,
                        class: "mt-4"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(Math.floor(progress.value)) + "% ", 1)
                        ]),
                        _: 1
                      }, 8, ["model-value", "active"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_row, { class: "ma-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pa-0"
                  }, {
                    default: _withCtx(() => [
                      _cache[16] || (_cache[16] = _createElementVNode("h3", null, " Búsqueda ", -1)),
                      _createVNode(_component_v_select, {
                        modelValue: haulTruckSelected.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((haulTruckSelected).value = $event)),
                        items: computedListTruck.value,
                        disabled: computedListTruck.value.length == 0 || disabledAXIOS.value,
                        "item-title": "title",
                        "item-value": "value",
                        density: "compact",
                        variant: "outlined",
                        "hide-details": ""
                      }, null, 8, ["modelValue", "items", "disabled"]),
                      _createVNode(_component_v_btn, {
                        class: "mt-4",
                        color: "success",
                        disabled: haulTruckSelected.value==='' || disabledAXIOS.value,
                        block: "",
                        onClick: getHaulTruckPositions
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('buttons.searchTruck')), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (showError.value)
                ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createTextVNode("No hay informacion", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_checkbox, {
                modelValue: mostrarEquipos.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((mostrarEquipos).value = $event)),
                color: "green",
                label: "Mostrar Equipos",
                "hide-details": ""
              }, null, 8, ["modelValue"]),
              (showCheckBoxes.value)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 2,
                    class: "ma-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        class: "pa-0",
                        cols: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_checkbox, {
                            modelValue: selectedETH0.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedETH0).value = $event)),
                            color: "green",
                            label: "ETH0",
                            "hide-details": ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_checkbox, {
                            modelValue: selectedRPTPEER.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedRPTPEER).value = $event)),
                            color: "green",
                            label: "RPTPEER",
                            "hide-details": ""
                          }, null, 8, ["modelValue"]),
                          (finalWLAN0Array.value.length > 0)
                            ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                key: 0,
                                modelValue: selectedWLAN0.value,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedWLAN0).value = $event)),
                                color: "green",
                                label: "WLAN0",
                                "hide-details": ""
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                          (finalWLAN1Array.value.length > 0)
                            ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                key: 1,
                                modelValue: selectedWLAN1.value,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedWLAN1).value = $event)),
                                color: "green",
                                label: "WLAN1",
                                "hide-details": ""
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                          (finalWLAN2Array.value.length > 0)
                            ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                key: 2,
                                modelValue: selectedWLAN2.value,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedWLAN2).value = $event)),
                                color: "green",
                                label: "WLAN2",
                                "hide-details": ""
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                          (finalWLAN3Array.value.length > 0)
                            ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                key: 3,
                                modelValue: selectedWLAN3.value,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedWLAN3).value = $event)),
                                color: "green",
                                label: "WLAN3",
                                "hide-details": ""
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                          (finalLATENCIAArray.value.length > 0)
                            ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                key: 4,
                                modelValue: selectedLATENCIA.value,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedLATENCIA).value = $event)),
                                color: "green",
                                label: "LATENCIA",
                                "hide-details": ""
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            color: "red",
                            block: "",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (getKMZ()))
                          }, {
                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                              _createTextVNode(" Generar KMZ ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["width"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})